export default {
  data() {
    return {
      cachePage: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      total: 0
    }
  },
  methods: {
    search(data, pageObj, api) {
      if (!data) {
        data = this.cacheData
      }
      if (!pageObj) {
        pageObj = {
          pageSize: 10,
          pageNum: 1
        }
        this.$refs.table && this.$refs.table.resetPage()
      }
      this.cacheData = data
      this.cachePage = pageObj
      const params = {
        ...data,
        ...pageObj
      }
      for (let item in params) {
        if (params[item]) {
          params[item] = Array.prototype.isPrototypeOf(params[item])
            ? params[item].join(',')
            : params[item]
        }
      }
      this.$store.commit('SET_TABLE_LOADING', true)
      return this.$ajax
        .get(api, params)
        .then((res) => {
          this.tableData = res.data.list
          this.total = res.data.total
          this.$nextTick(() => {
            this.$store.commit('SET_TABLE_LOADING', false)
          })
          return res
        })
        .catch(() => {
          this.tableData = []
          this.total = 0
          this.$nextTick(() => {
            this.$store.commit('SET_TABLE_LOADING', false)
          })
          return {}
        })
    },
    handleTableChange(data) {
      this.search(null, data, this.queryApi)
    }
  }
}
